import { render, staticRenderFns } from "./WyhSettingPassword.vue?vue&type=template&id=a6ec068c&scoped=true&"
import script from "./WyhSettingPassword.vue?vue&type=script&lang=js&"
export * from "./WyhSettingPassword.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingPassword.vue?vue&type=style&index=0&id=a6ec068c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ec068c",
  null
  
)

export default component.exports